import { createContext, type PropsWithChildren, useMemo } from "react";
import type { ExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHubStore.ts";

type ExonnHubProviderProps = {
  store: ExonnHubStore;
  orderId: string;
};

export const ExonnHubContext = createContext<null | {
  store: ExonnHubStore;
  orderId: string;
}>(null);

export const ExonnHubProvider = ({
  children,
  store,
  orderId,
}: PropsWithChildren<ExonnHubProviderProps>) => {
  const context = useMemo(
    () => ({
      store,
      orderId,
    }),
    [store, orderId],
  );
  return (
    <ExonnHubContext.Provider value={context}>
      {children}
    </ExonnHubContext.Provider>
  );
};
